export enum RoyalProvisionRewardKey {
	InventoryStorageBoost = "inventoryStorageBoost",
	ExploringPowerBoost = "exploringPowerBoost",
	ExtendedOfflineIncome = "extendedOfflineIncome",
	DoubleDailyReward = "doubleDailyReward",
}

type RoyalProvisionReward = {
	title: string;
	description: string;
	icon: string;
	value?: number;
	minutes?: number;
	number?: number;
	baseMultiplier?: number;
	percentage?: number;
};

export const royalProvisionRewards = {
	[RoyalProvisionRewardKey.InventoryStorageBoost]: {
		title: "ui.bigger_storage",
		description: "ui.bigger_storage_description",
		icon: "icon-upgrade-41",
		value: 1.3,
		percentage: 30,
	},
	[RoyalProvisionRewardKey.ExploringPowerBoost]: {
		title: "ui.faster_exploration",
		description: "ui.faster_exploration_description",
		icon: "icon-upgrade-39",
		value: 1.3,
		percentage: 30,
	},
	[RoyalProvisionRewardKey.ExtendedOfflineIncome]: {
		title: "ui.better_offline_income",
		description: "upgrade.max_offline_time_description",
		icon: "icon-upgrade-75",
		minutes: 120,
		number: 120,
	},
	[RoyalProvisionRewardKey.DoubleDailyReward]: {
		title: "ui.bigger_daily_rewards",
		description: "upgrade.daily_reward_description",
		icon: "icon-upgrade-27",
		baseMultiplier: 2,
		percentage: 100,
	},
} as Record<RoyalProvisionRewardKey, RoyalProvisionReward>;
